// We route listing-bookings through the marketplace server (not directly to Crion API)
// so the server can deduplicate: when a booking is made, the Crion API creates one
// booking record per session in listingSessionIds (booked + overlap-blocked). The server
// drops the overlap-blocked records using protectedData.bookedSessionDateRanges from
// the Sharetribe transaction, so the provider calendar shows only the booked days.
import Axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { getTokenStore } from '../../util/tokenStore';

const fetchBookings = params => {
  const token = getTokenStore().getToken()?.access_token;
  return Axios.get(`${apiBaseUrl()}/api/listing-bookings`, {
    params,
    withCredentials: true,
    ...(token && { headers: { Authorization: `Bearer ${token}` } }),
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { fetchBookings };
